import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { editFeaturesGroup, 
        deleteCards, 
        editCards, 
        popUpMessageChange, 
        editFigures } from '../../actions/index';

import { Button } from '@material-ui/core';

import { _ } from '../../functions/translator.js';
import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';

class ReopenConfirmation extends React.Component{

    handleClose = () => {
        this.props.popUpMessageChange({ show: false })
    }

    handleConfirm = async () => {
        showMessage(this.props, _('Reabriendo protocolos') + '...', { loading: true });
        let urlPost = {
            'cards_group_ids': this.props.cardsGroupIds,
            'project_id': window.project_id
        }
        let response = await postData('/web-api/batch-reopen', urlPost);
        this.handleResponse(response);
    }

    handleResponse = (response) => {
        if (response.status === 'success') {
            if (this.props.cardsGroupIds.length > 1) {
                showMessage(this.props, '¡' + _('Protocolos Reabiertos exitosamente') + '!');
            } else {
                showMessage(this.props, '¡' + _('Protocolo Reabierto exitosamente') + '!');
            }
            reloadCardsGroupsFeatures(this.props, this.props.cardsGroupIds);
        } else {
            showMessage(this.props, _('Ocurrió un error al reabrir los protocolos'));
        }
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-around mt-4">
                    <Button variant="contained" className='confirm-warning-button' onClick={ this.handleConfirm }>
                        { _('Reabrir') }
                    </Button>
                    <Button variant="contained" className='confirm-cancel-button' onClick={ this.handleClose }>
                        { _('Cancelar') }
                    </Button>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        editCards : editCards,
        deleteCards : deleteCards,
        editFeaturesGroup : editFeaturesGroup,
        popUpMessageChange : popUpMessageChange,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ReopenConfirmation)